import { serviceApi } from '~/api';

const treatmentCategoriesUrl = 'treatment-categories';

export const get = () => serviceApi.fetchJSON(treatmentCategoriesUrl);

export const getById = (treatmentCategoryId) =>
  serviceApi.fetchJSON(`${treatmentCategoriesUrl}/${treatmentCategoryId}`, { method: 'GET' });

export const treatmentCategoriesApi = {
  get,
  getById,
};
